import createSelector from 'web-app/util/custom-create-selector';
import StaffEntity from 'signin-app/entities/staff';
export const staffGroup = createSelector(StaffEntity.selectors.entityMap, (_, props) => props.staffGroupId, (staffEntityMap, groupId) => {
    return staffEntityMap.find((_, staffGroupId) => staffGroupId === groupId);
});
